export function initViewBtns() {
    const viewBtns = $('.catalog__view-buttons--item');
    const filterResult = document.getElementById('filter-result');
    const recommendedList = document.querySelector('.recommended-list');

    viewBtns.on('click', (e) => {
        const currentBtn = e.currentTarget;
        const galleryType = currentBtn.dataset.type;

        $(currentBtn).siblings().removeClass('active');
        currentBtn.classList.add('active');

        if (galleryType === 'grid') {
            filterResult.classList.add('grid');
            recommendedList.classList.add('grid');
        } else {
            filterResult.classList.remove('grid');
            recommendedList.classList.remove('grid');
        }
    });
}
